import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".mySwiper", {
        spaceBetween: 14,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        1280: {  //当屏幕宽度小于等于1280
            slidesPerView: 5,
            spaceBetween: 14,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 4,
            spaceBetween: 14,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 14,
        }
    });
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

